import { api } from 'app/store';
import { IAssociatedUtilitiesJSON } from 'api';
import { makeUseRequest } from 'hooks';

export const useAssociatedUtilities = makeUseRequest<IAssociatedUtilitiesJSON>(
  api.associatedUtility.fetchAll.bind(api.associatedUtility)
);
